import { render, staticRenderFns } from "./FileCollectionUpload.vue?vue&type=template&id=59af7bc6"
import script from "./FileCollectionUpload.vue?vue&type=script&lang=ts"
export * from "./FileCollectionUpload.vue?vue&type=script&lang=ts"
import style0 from "./FileCollectionUpload.vue?vue&type=style&index=0&id=59af7bc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports